export const addressEditFields = [
  {
    name: 'organisation',
    label: 'Organisation',
  },
  {
    name: 'number',
    label: 'Building number',
  },
  {
    name: 'buildingname',
    label: 'Building name',
  },
  {
    name: 'subbuildingname',
    label: 'Flat number',
  },
  {
    name: 'street',
    label: 'Street',
  },
  {
    name: 'posttown',
    label: 'Town or city',
  },
  {
    name: 'postcode',
    label: 'Postcode',
  },
  {
    name: 'country',
    label: 'Country',
  },
]
